module.exports = __webpack_public_path__ + "img/malefarmer.f3c4f1bb.png";